import React from 'react'
import { Button, IconChevronLeftDefault } from '@mc/design-system'
import { paths } from '@mc/paths'
import i18nInstance from '../../i18n/i18nInstance'

const I18N_NS = '@mc/global-navigation'

const t = (key: string) => i18nInstance.t(key, { ns: I18N_NS })

interface CertificateEntry {
  title: string
  slug: string
  availableSoon?: boolean
}

const LATEST_CERTIFICATES: CertificateEntry[] = [
  {
    title: 'Leadership and Decision-Making Under Pressure',
    slug: 'leadership-and-decision-making-under-pressure',
  },
  {
    title: 'Breakthrough Innovation Strategy',
    slug: 'breakthrough-innovation-strategy-from-bold-idea-to-business-impact',
  },
  {
    title: 'Scaling AI Strategy',
    slug: 'scaling-ai-strategy-build-launch-and-drive-what-s-next',
    availableSoon: true,
  },
  {
    title: 'Lead With AI',
    slug: 'lead-with-ai-adapt-implement-transform-your-organization',
    availableSoon: true,
  },
]

interface CertificatesSectionProps {
  onHideCertificatesSection: () => void
}

export const CertificatesSection = ({
  onHideCertificatesSection,
}: CertificatesSectionProps) => (
  <div className='mc-px-4'>
    <Button
      className='mc-p-3 mc-my-5'
      onClick={onHideCertificatesSection}
      kind='tertiary'
      symmetrical
    >
      <IconChevronLeftDefault size='sm' srText={t('nav.cta.back')} />
    </Button>
    <div className='mc-corners--md mc-p-4 mc-bg-container-tint-medium'>
      <ul>
        {LATEST_CERTIFICATES.filter((cert) => !cert.availableSoon).map(
          (cert) => (
            <li key={cert.slug} className='mc-mb-4'>
              <a href={paths.certificate(cert.slug)}>{cert.title}</a>
            </li>
          ),
        )}
        <li>
          <a href={paths.certificates}>{t('nav.cta.viewAllCertificates')}</a>
        </li>
      </ul>
    </div>
  </div>
)
